import { render, staticRenderFns } from "./PetHealthDetail.vue?vue&type=template&id=f4eb0aa4&scoped=true&"
import script from "./PetHealthDetail.vue?vue&type=script&lang=js&"
export * from "./PetHealthDetail.vue?vue&type=script&lang=js&"
import style0 from "./PetHealthDetail.vue?vue&type=style&index=0&id=f4eb0aa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4eb0aa4",
  null
  
)

export default component.exports